export default __webpack_public_path__ + "static/media/bg-pattern-big.c82531b7.svg";